/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

// material ui icons
import MailOutline from "@material-ui/icons/Business";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import MyForm from "components/Form";


// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";

import { connect } from "react-redux";
import { crudActions, loaderActions } from "../../../_actions";
import { crudService } from "../../../_services";

import SimpleReactValidator from "simple-react-validator";

const initialState = {
    id: "new",
    form: {
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        image: "",
        profile_summary: "",
        country_id: "",
        linkedin_url: "",
        open_to_work: true,
        years_of_experience: "",
        skills: [],
        resume: {
            file_path: ""
        },
        languages: []
    },
};
class JobSeekerForm extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = initialState;

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    }

    handleInputChange(event) {
        const newState = Object.assign({}, this.state);
        if (event.target.type == "checkbox") {
            newState.form[event.target.name] = event.target.checked;
        } else if (event.target.name == 'file_path') {
            newState.form.resume[event.target.name] = event.target.value;

        } else {
            newState.form[event.target.name] = event.target.value;

        }
        this.setState(newState);
        this.handleError();
    }

    getFormFields = () => {
        const { form } = this.state;
        const formFields = [
            {
                name: "first_name",
                label: "First Name",
                type: "textbox",
                value: form.first_name || "",
                icon: "assignment",
                error: this.validator.message(
                    "name",
                    form.first_name,
                    "required|min:3"
                ),
            },
            {
                name: "last_name",
                label: "Last Name",
                type: "textbox",
                value: form.last_name || "",
                icon: "assignment",
                error: this.validator.message(
                    "name",
                    form.last_name,
                    "required|min:3"
                ),
            },
            {
                name: "image",
                label: "Upload Image",
                type: "imageUpload",
                uploadUrl: "upload/image",
                value: form.image || "",
                icon: "image",
            },
            {
                name: "file_path",
                label: "Upload Resume",
                type: "file",
                uploadUrl: "upload/document",
                value: form.resume.file_path || "",
                icon: "assignment",
            },
            {
                name: "years_of_experience",
                label: "Years of Experience",
                type: "number",
                value: form.years_of_experience || "",
                icon: "assignment",
            },
            {
                name: "mobile",
                label: "Mobile",
                type: "textbox",
                value: form.mobile || "",
                icon: "call",
            },
            {
                name: "email",
                label: "Email",
                type: "textbox",
                value: form.email || "",
                icon: "email",
                error: this.validator.message("email", form.email, "required"),
            },
            {
                name: "skills",
                label: "Skills",
                type: "multi_autocomplete",
                url: "skills?only_parent=true",
                getOptionLabel: "name",
                getOptionValue: "id",
                value: form.skills,
                option: { label: form.skill_id, value: form.skill_id },
                error: this.validator.message("skills", form.skills, "required"),
            },
            {
                name: "country_id",
                label: "Country",
                type: "autocomplete",
                url: "countries",
                getOptionLabel: "name",
                getOptionValue: "id",
                value: form.country_id,
                option: { label: form.country_id, value: form.country_id },
                error: this.validator.message(
                    "country_id",
                    form.country_id,
                    "required"
                ),
            },
            {
                name: "profile_summary",
                label: "Profile Summary",
                type: "textbox",
                value: form.profile_summary || "",
                icon: "assignment",
            },
            {
                name: "linkedin_url",
                label: "Linkedin URL",
                type: "textbox",
                value: form.linkedin_url || "",
                error: this.validator.message(
                    "Linkedin URL",
                    form.linkedin_url,
                    "required|url"
                ),
            },
            {
                name: "languages",
                label: "Languages",
                type: "multi_autocomplete",
                url: "languages",
                getOptionLabel: "name",
                getOptionValue: "id",
                value: form.languages,
                option: { label: form.language_id, value: form.language_id },
                error: this.validator.message("languages", form.languages, "required"),
            },
        ];

        return formFields;
    };

    getValue(val) {
        const { id } = this.props.match.params;
        if (id && id === "new") {
            return val;
        } else {
            if (null === val) {
                return "";
            } else {
                return val;
            }
        }
    }

    handleError() {
        this.validator.showMessages();
        this.forceUpdate();
    }

    goBack = () => {
        this.props.history.goBack();
    };
    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            let data = {
                first_name: this.state.form.first_name,
                last_name: this.state.form.last_name,
                email: this.state.form.email,
                mobile: this.state.form.mobile,
                image: this.state.form.image,
                profile_summary: this.state.form.profile_summary,
                country_id: this.state.form.country_id,
                linkedin_url: this.state.form.linkedin_url,
                years_of_experience: this.state.form.years_of_experience,
                skills: this.state.form.skills.map(skill => skill.id),
                resume: this.state.form.resume.file_path,
                languages: this.state.form.languages.map(language => language.id),
            };
            const { id } = this.props.match.params;
            if (id && id === "new") {
                this.props.create("formData", "jobseekers", data);
                this.goBack();
            } else {
                this.props.update("formData", "jobseekers", id, data);
                this.goBack();
            }
        } else {
            this.handleError();
        }
    }

    bindData = () => {
        const { id } = this.props.match.params;
        if (id && id !== "new") {
            crudService._get("jobseekers", id).then((response) => {
                if (response.status === 200) {
                    this.setState({
                        form: response.data,
                    });
                }
            });
        }
    };

    componentDidMount() {
        this.bindData();
    }

    render() {
        const { classes } = this.props;
        const { id } = this.props.match.params;
        let title = "Add New Job Seeker";
        let btnText = "Create";
        if (id && id !== "new") {
            title = "Edit Job Seeker Details";
            btnText = "Update";
        }


        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={8}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <MailOutline />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{title}</h4>
                        </CardHeader>
                        <CardBody>
                            <MyForm
                                handleInputChange={this.handleInputChange}
                                formFields={this.getFormFields()}
                                handleSubmit={this.handleSubmit}
                                handleCancel={this.goBack}
                                btnText={btnText}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        );
    }
}

JobSeekerForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    const { form, confirm } = state;
    return {
        form,
        confirm,
    };
};

const actionCreators = {
    getAll: crudActions._getAll,
    getCrud: crudActions._get,
    getAllParam: crudActions._getAllWithParam,
    clearCrud: crudActions._clear,
    create: crudActions._create,
    update: crudActions._update,
    showLoader: loaderActions.show,
    hideLoader: loaderActions.hide,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        actionCreators
    )(JobSeekerForm)
);